import * as React from "react"
import CreativeCommunity from '../../components/Creative-Community/CreativeCommunity';
import Layout from "../../components/layout"
import Seo from "../../components/seo"
import { graphql } from "gatsby"


const IndexPage = ({data}) => (
  <Layout>
    <Seo title="Home" />
      <CreativeCommunity data={data} />
  </Layout>
)

export default IndexPage;

export const query = graphql`
  {
    allContentfulElbrusPagesInTheWild(
      filter: {slug: {eq: "creative-community"}, node_locale: {eq: "en-US"}}
    ) {
      nodes {
        id
        displayName
        contentful_id
        slug
        subTitle
        subTitleTag
        tagSlug
        title
        titleCaption
      }
    }
  }`